<template>
  <b-modal
    ref="modal"
    id="clients-details-modal"
    hide-header
    centered
    no-close-on-backdrop
    @show="onShow"
    @hide="onHide"
  >
    <h2><span>{{ client.nameVi }}</span> <span>{{`(#${client.publicId})`}}</span></h2>
    <div class="call-btn">
      <toggle-box v-if="isDesktop" ref="callBtn" has-border>
        <template v-slot:control>
          <div class="call-btn-wrapper" @click="showPhoneNumbersList">
            <font-awesome-icon :icon="faPhone" />
          </div>
        </template>
        <template v-slot:content>
          <h4>{{ $t('SELECT_PHONE_NUMBER_TO_CALL') }}</h4>
          <ul>
            <li v-if="!!primary">
              <div class="text">
                <small>{{ $t('PRIMARY_NUMBER') }}</small>
                <br />
                <span>{{ primary }}</span>
              </div>
              <div class="call-btn-wrapper" @click="startCall(primary)">
                <font-awesome-icon :icon="faPhone" />
              </div>
            </li>
            <li v-if="!!secondary">
              <div class="text">
                <small>{{ $t('SECONDARY_NUMBER') }}</small>
                <br />
                <span>{{ secondary }}</span>
              </div>
              <div class="call-btn-wrapper" @click="startCall(secondary)">
                <font-awesome-icon :icon="faPhone" />
              </div>
            </li>
          </ul>
        </template>
      </toggle-box>
      <div class="d-flex justify-content-start align-items-center" v-else>
        <div class="call-btn-wrapper" @click="showPhoneNumbersList">
          <font-awesome-icon :icon="faPhone" />
        </div>
        <bottom-sheet v-model="callBottomSheetOpen" :openY="0.3">
          <center><h4>{{ $t('SELECT_PHONE_NUMBER_TO_CALL') }}</h4></center>
          <div v-if="!!primary" class="d-flex justify-content-around align-items-center">
            {{ $t('PRIMARY_NUMBER') }}
            <span>{{ primary }}</span>
            <div class="call-btn-wrapper" @click="startCall(primary)">
              <font-awesome-icon :icon="faPhone" />
            </div>
          </div>
          <br/>
          <div v-if="!!secondary" class="d-flex justify-content-around align-items-center">
            {{ $t('SECONDARY_NUMBER') }}
            <span>{{ primary }}</span>
            <div class="call-btn-wrapper" @click="startCall(secondary)">
              <font-awesome-icon :icon="faPhone" />
            </div>
          </div>
        </bottom-sheet>
        <div class="exit">
          <center>
            <font-awesome-icon @click="cancel" :icon="faTimes" />
          </center>
        </div>
      </div>
    </div>
    <b-row>
      <b-col xs="12" lg="9" xl="8" class="payment-reminder-result-wrapper">
        <div class="payment-reminder-result">
          <div class="title">{{ $t('PAYMENT_REMINDER_RESULT') }}</div>
          <div class="body">
            <b-row align-h="between">
              <b-col xs="12" md="8">
                <b-row>
                  <b-col xs="12" md="6" class="col-right">
                    <div class="label">{{ $t('STATUS') }}</div>
                    <small>{{ $t('NOTE_DOWN_CALL_RESULT') }}</small>
                    <auto-complete-input v-model="paymentReminderStatus" required :items="paymentReminderStatusOptions" />
                  </b-col>
                  <b-col xs="12" md="6" class="col-right">
                    <div class="label">{{ $t('CLT_ATTITUDE') }}</div>
                    <small>{{ $t('NOTE_DOWN_CALL_RESULT') }}</small>
                    <auto-complete-input v-model="paymentReminderClientAttitude" required :items="paymentReminderClientAttitudeOptions" />
                  </b-col>
                </b-row>
                <br/>
                <b-row>
                  <b-col xs="12" md="6" class="col-right">
                    <div class="label">{{ $t('NEXT_ACTION') }}</div>
                    <small>{{ $t('NOTE_DOWN_NEXT_ACTION') }}</small>
                    <auto-complete-input v-model="paymentReminderNextAction" required :items="paymentReminderNextActionOptions" />
                  </b-col>
                  <b-col xs="12" md="6" class="col-right payment-date">
                    <div class="label">{{ $t('NEXT_ACTION_TIME') }}</div>
                    <small>{{ $t('SELECT_TIME_NEXT_ACTION') }}</small>
                    <toggle-box v-if="isDesktop" ref="nextActionDateBox">
                      <template v-slot:control>
                        <text-input
                          v-model="paymentReminderNextActionDate"
                          @focus="showNextActionCalendar(true)"
                          ref="nextActionInput"
                        >
                          <template v-slot:icon>
                            <font-awesome-icon class="icon" :icon="faCalendarAlt" />
                          </template>
                        </text-input>
                      </template>
                      <template v-slot:content>
                        <date-time v-model="paymentReminderNextActionDate"/>
                        <div class="d-flex justify-content-end">
                          <primary-button red rounded-corner :text="$t('OK')" @click="toggleOffAppointmentBox" />
                        </div>
                      </template>
                    </toggle-box>
                    <div v-else>
                      <text-input
                        v-model="paymentReminderNextActionDate"
                        @focus="showNextActionCalendar(true)"
                        ref="nextActionInput"
                      >
                        <template v-slot:icon>
                          <font-awesome-icon class="icon" :icon="faCalendarAlt" />
                        </template>
                      </text-input>
                      <bottom-sheet v-model="paymentReminderBottomSheetOpen">
                        <date-time v-model="paymentReminderNextActionDate"/>
                        <div class="d-flex justify-content-end">
                          <primary-button class="marginRight" blue rounded-corner :text="$t('RESET')" @click="cancelAppointmentBox" />
                          <primary-button class="marginRight" red rounded-corner :text="$t('OK')" @click="toggleOffAppointmentBox" />
                        </div>
                      </bottom-sheet>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col xs="12" md="4" class="payment-date">
                <div class="label">{{ $t('PAYMENT_DATE') }}</div>
                <small>{{ $t('SELECT_DATE_TO_CALCULATE_PAYMENT') }}</small>
                <toggle-box v-if="isDesktop" ref="paymentDateBox">
                  <template v-slot:control>
                    <text-input
                      v-model="paymentDate"
                      @focus="showCalendar(true)"
                      ref="paymentDateInput"
                    >
                      <template v-slot:icon>
                        <font-awesome-icon class="icon" :icon="faCalendarAlt" />
                      </template>
                    </text-input>
                  </template>
                  <template v-slot:content>
                    <calendar
                      :date="paymentDate || undefined"
                      @dateChange="setPaymentDate"
                    />
                  </template>
                </toggle-box>
                <div v-else>
                  <text-input
                    v-model="paymentDate"
                    @focus="showCalendar(true)"
                    ref="paymentDateInput"
                  >
                    <template v-slot:icon>
                      <font-awesome-icon class="icon" :icon="faCalendarAlt" />
                    </template>
                  </text-input>
                  <bottom-sheet v-model="calendarBottomSheetOpen" :openY="0.3">
                    <center class="marginTop">
                      <calendar
                        :date="paymentDate || undefined"
                        @dateChange="setPaymentDate"
                      />
                    </center>
                  </bottom-sheet>
                </div>
              </b-col>
            </b-row>

            <div class="multiple-notes-input">
              <ul class="contract-ids">
                <li
                  v-for="item in dueContracts"
                  :key="item.id"
                  :class="{ active: (contractsToSendNotes.indexOf(item.id) >= 0) }"
                  @click="() => toggleContractsToSend(item.id)"
                >
                  {{`#${item.publicId}`}}
                </li>
              </ul>

              <small>{{ $t('SELECT_CNTRCT_IDS_TO_SEND_NOTES') }}</small>

              <form @submit="addNotes">
                <text-input
                  :placeholder="$t('ENTER_NOTES')"
                  icon-position="right"
                  v-model="notesInputVal"
                  ref="notesInput"
                >
                  <template v-slot:icon>
                    <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="addNotes" />
                  </template>
                </text-input>
                <button type="submit" cloak />
              </form>
            </div>
          </div>
        </div>
      </b-col>
      <b-col xs="12" lg="3" xl="4">
        <div class="payment-calculation">
          <table class="payment-details">
            <thead>
              <tr>
                <th>{{ $t('CNTRCT_ID') }}</th>
                <th>{{ $t('RENEW') }}</th>
                <th>{{ $t('REDEEM') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dueContracts"
                :key="item.id"
                :class="{
                  extra: item.maturesOn > filters.toDate
                }"
              >
                <td>{{ item.publicId }}</td>
                <td>{{ item.toRenew ? addCommas(item.interestAmount + item.roundingFee - item.renewalDifference + item.overdueFee + item.storageFee - item.repaidAmount - item.waivedAmount + calculateAdjustedAmountForRenewal(item)) : '-' }}</td>
                <td>{{ item.toRepay ? addCommas(item.principalAmount + item.interestAmount + item.roundingFee - item.renewalDifference + item.overdueFee - item.repaidAmount - item.waivedAmount) : '-' }}</td>
              </tr>
              <tr>
                <td colspan="2" class="total">{{ `${$t('TOTAL_AMOUNT')}: ` }}</td>
                <td>{{ addCommas(totalAmount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <div class="marginTop">
      <table :class="{ 'payment-details': isDesktop, 'payment-detail-mobile': !isDesktop }">
        <thead v-if="isDesktop">
          <tr>
            <th>{{ $t('CNTRCT_ID') }}</th>
            <th>{{ $t('DUE_DATE') }}</th>
            <th>{{ $t('LATE_DAYS') }}</th>
            <th>{{ $t('ASSET') }}</th>
            <th>{{ $t('APPROVED_AMOUNT') }}</th>
            <th>{{ $t('INTEREST') }}</th>
            <th>{{ $t('OVERDUE_FEE') }}</th>
            <th>{{ $t('WAIVED_AMOUNT') }}</th>
            <th>{{ $t('OLD_CNTRCT_PENALTY')}}
            <th>{{ $t('REPAID_AMOUNT')}}</th>
            <th>{{ $t('VALUE_ADJUSTMENT') }}</th>
            <th>{{ $t('STORAGE_FEE') }}</th>
            <th>{{ $t('STORAGE') }}</th>
            <th>{{ $t('ACTIONS') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, i) in dueContracts">
            <tr
              class="contract-info"
              :key="`info-${item.id}`"
              :class="{
                inactive: item.asset.status === ASSET_STATUSES.WAITING_TO_LIQUIDIZE,
                extra: item.maturesOn > filters.toDate
              }"
            >
              <td>
                <div class="mobile-header" v-if="!isDesktop">{{ $t('CNTRCT_ID') }}:</div>
                <router-link :to="applyParams(PATHS.CONTRACT_DETAIL, item.publicId)">{{ item.publicId }}</router-link>
              </td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('DUE_DATE') }}:</div>{{ item.maturesOn }}</td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('LATE_DAYS') }}:</div>{{ item.lateDays }}</td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('ASSET') }}:</div><div v-html="getFullDescription(item.asset)" /></td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('APPROVED_AMOUNT') }}:</div>{{ addCommas(item.approvedAmount) }}</td>
              <td class="subtitle">
                <div class="mobile-header" v-if="!isDesktop">{{ $t('INTEREST') }}:</div>
                <span>{{ addCommas(item.interestAmount) }}</span>
                <div v-if="!!item.roundingFee">
                  <small>+{{ addCommas(item.roundingFee) }}</small>
                </div>
              </td>
              <td class="subtitle">
                <div class="mobile-header" v-if="!isDesktop">{{ $t('OVERDUE_FEE') }}:</div>
                <span>{{ addCommas(item.overdueFee) }}</span>
                <br />
                <small>{{ addCommas(Math.round(item.overdueFeePerDay)) }}</small>
              </td>
              <td class="subtitle">
                <div class="mobile-header" v-if="!isDesktop">{{ $t('WAIVED_AMOUNT') }}:</div>
                <span>{{ addCommas(item.waivedAmount) }}</span>
              </td>
              <td>
                <div class="mobile-header" v-if="!isDesktop">{{ $t('OLD_CNTRCT_PENALTY') }}</div>
                <div>{{ (item.renewalDifference > 0) ? 0 : addCommas(Math.abs(item.renewalDifference))}}</div>
              </td>
              <td>
                <div class="mobile-header" v-if="!isDesktop">{{ $t('REPAID_AMOUNT') }}:</div>
                <div>{{ item.repaidAmount + ( item.renewalDifference > 0 ? item.renewalDifference : 0) }}</div>
              </td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('VALUE_ADJUSTMENT') }}:</div>{{ addCommas(item.adjustedAmount) }}</td>
              <td class="subtitle">
                <div class="mobile-header" v-if="!isDesktop">{{ $t('STORAGE_FEE') }}:</div>
                <span>{{ addCommas(item.storageFee) }}</span>
                <div v-if="!!item.storageFee">
                  <small>{{ $t('NUMBER_DAYS', { numberOfDays: item.product.loanTerm }) }}</small>
                </div>
              </td>
              <td><div class="mobile-header" v-if="!isDesktop">{{ $t('STORAGE') }}:</div>{{ item.asset.storage ? item.asset.storage.name : 'n/a' }}</td>
              <td class="actions">
                <div class="mobile-header" v-if="!isDesktop">{{ $t('ACTIONS') }}:</div>
                <div
                  class="icon liquidize"
                  :class="{ inactive: item.asset.status === ASSET_STATUSES.WAITING_TO_LIQUIDIZE }"
                  @click="confirm(item)"
                  v-if="false"
                >
                  <font-awesome-icon :icon="faShoppingCart" />
                </div>
                <div
                  class="icon extend"
                  :class="{ active: !!item.toRenew }"
                  @click="toggleRenew(item)"
                >
                  <font-awesome-icon :icon="faHourglass" />
                </div>
                <div
                  class="icon finalize"
                  :class="{ active: !!item.toRepay }"
                  @click="toggleFinalize(item)"
                >
                  <font-awesome-icon :icon="faCheckCircle" />
                </div>
                <div class="icon toggle-notes" @click="toggleNotes(i)" :class="{ active: !!item.active }">
                  <font-awesome-icon :icon="faChevronDown" />
                </div>
              </td>
            </tr>
            <contract-notes :key="`notes-${item.id}`" :id="item.id" :active="!!item.active" />
          </template>
        </tbody>
      </table>
    </div>

    <div slot="modal-footer">
      <primary-button @click="cancel" grey rounded-corner :text="$t('CANCEL')" />
      <primary-button @click="off" blue rounded-corner :text="$t('OK')" />
    </div>
    <confirm-modal />
  </b-modal>
</template>

<script>
import { watch, ref, getCurrentInstance, computed, onMounted, onUnmounted } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faTimes,
  faShoppingCart,
  faHourglass,
  faCheckCircle,
  faChevronDown,
  faCalendarAlt,
  faPhone,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import ConfirmModal from '@/components/ConfirmModal';
import PrimaryButton from '@/components/PrimaryButton';
import TextInput from '@/components/TextInput';
import Calendar from '@/components/Calendar';
import DateTime from '@/components/DateTime';
import ToggleBox from '@/components/ToggleBox';
import BottomSheet from '@/components/BottomSheet';
import AutoCompleteInput from '@/components/AutoCompleteInput';

import { addCommas, camelToUpperSnake, applyParams } from '@/helpers';
import { DATE_FORMAT, DATE_TIME_FORMAT, ASSET_STATUSES, INTEREST_TYPE } from '@/consts';
import PATHS from '@/consts/paths';
import logService from '@/services/log';
import loans from '@/services/loans';
import logKeys from '@/consts/logKeys';

import paymentReminderServices from '../PaymentReminderServices';
import ContractNotes from './ContractNotes';

const { useGetters: useModalGetters, useActions: useModalActions } = createNamespacedHelpers('modal');
const { useActions: useConfirmActions } = createNamespacedHelpers('confirm');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useState: useAppState, useActions: useAppActions } = createNamespacedHelpers('app');
const { useState } = createNamespacedHelpers('paymentReminder');
const { useActions: usePhoneActions } = createNamespacedHelpers('phone');

const now = moment();

export default {
  name: 'ClientDetailsModal',
  components: {
    PrimaryButton,
    FontAwesomeIcon,
    TextInput,
    Calendar,
    DateTime,
    ToggleBox,
    ConfirmModal,
    ContractNotes,
    BottomSheet,
    AutoCompleteInput
  },
  setup(props, { refs, root }) {
    const vm = getCurrentInstance();

    const { isPaymentReminderClientDetailsModalActive: isOpen } = useModalGetters(['isPaymentReminderClientDetailsModalActive']);
    const { togglePaymentReminderClientDetailsModal: toggle, toggleConfirmModal } = useModalActions(['togglePaymentReminderClientDetailsModal', 'toggleConfirmModal']);
    const { isDesktop } = useAppState(['isDesktop']);
    const { targetingClient: client, filters } = useState(['targetingClient', 'filters']);
    const { startOutboundCall } = usePhoneActions(['startOutboundCall']);
    const { setTitleModal, setOnConfirm } = useConfirmActions(['setTitleModal', 'setOnConfirm']);
    const { info, error } = useFlashActions(['info', 'error']);

    const totalAmount = ref(0);
    const paymentDate = ref(null);
    const dueContracts = ref([]);
    const primary = ref('');
    const secondary = ref('');
    const notesInputVal = ref('');
    const notesInput = ref(null);
    const contractsToSendNotes = ref([]);
    const callBottomSheetOpen = ref(false);
    const paymentReminderBottomSheetOpen = ref(false);
    const calendarBottomSheetOpen = ref(false);

    const {
      paymentReminderClientAttitudes,
      paymentReminderStatuses,
      paymentReminderNextActions
    } = useAppState([
      'paymentReminderClientAttitudes',
      'paymentReminderStatuses',
      'paymentReminderNextActions'
    ]);

    const paymentReminderStatus = ref(null);
    const paymentReminderStatusOptions = computed(() => paymentReminderStatuses.value.map((item) => ({
      value: item.id,
      text: vm.$t(item.key)
    })));

    const paymentReminderClientAttitude = ref(null);
    const paymentReminderClientAttitudeOptions = computed(() => paymentReminderClientAttitudes.value.map((item) => ({
      value: item.id,
      text: vm.$t(item.key)
    })));

    const paymentReminderNextAction = ref(null);
    const paymentReminderNextActionOptions = computed(() => paymentReminderNextActions.value.map((item) => ({
      value: item.id,
      text: vm.$t(item.key)
    })));

    const paymentReminderNextActionDate = ref('');

    const showNextActionCalendar = () => {
      if (isDesktop.value) {
        refs.nextActionDateBox.toggle(true);
      } else {
        paymentReminderBottomSheetOpen.value = true;
        if (paymentReminderNextActionDate.value === '') {
          paymentReminderNextActionDate.value = moment().format(DATE_TIME_FORMAT);
        }
      }
      refs.nextActionInput.blur();
    };

    const fetchClientInfo = async () => {
      const { publicId } = client.value;
      if (!publicId) return;

      const { primaryPhoneNumber, secondaryPhoneNumber } = await paymentReminderServices.getClientDetail(publicId);
      primary.value = primaryPhoneNumber;
      secondary.value = secondaryPhoneNumber;
    };

    const fetchDueContracts = async () => {
      const { id } = client.value;
      if (!id) return;

      const { fromDate, toDate: to } = filters.value;
      const toDate = moment(to).add(4, 'days').format(DATE_FORMAT);
      const items = await paymentReminderServices.getDueContractsByClient(id, fromDate, toDate);

      items.sort((x) => ((x.maturesOn > to) ? 1 : -1));

      dueContracts.value = items;
      paymentDate.value = now.format(DATE_FORMAT);
    };

    const fetchPaymentReminderResult = async () => {
      const { id } = client.value;
      const { items } = await paymentReminderServices.getPaymentReminderResultsListByClient(id);

      if (items.length) {
        paymentReminderStatus.value = items[0].statusId;
        paymentReminderClientAttitude.value = items[0].clientAttitudeId;
        paymentReminderNextAction.value = items[0].nextActionId;
        paymentReminderNextActionDate.value = moment(items[0].nextActionAt).format(DATE_TIME_FORMAT);
      } else {
        paymentReminderStatus.value = null;
        paymentReminderClientAttitude.value = null;
        paymentReminderNextAction.value = null;
        paymentReminderNextActionDate.value = '';
      }
    };

    const update = async () => {
      const { id } = client.value;

      const data = {
        clientAttitudeId: paymentReminderClientAttitude.value,
        statusId: paymentReminderStatus.value,
        nextActionId: paymentReminderNextAction.value || undefined,
        nextActionAt: paymentReminderNextAction.value ? paymentReminderNextActionDate.value : undefined
      };

      await paymentReminderServices.createPaymentReminderResult(id, data);

      refs.modal.hide();
      info(root.$t('PAYMENT_REMINDER_RESULT_CREATED'));
      logService.activityLog(logKeys.PAYMENT_REMINDER_UPDATE);
    };

    const cancel = async () => {
      refs.modal.hide();
    };

    const off = async () => {
      if (paymentReminderClientAttitude || paymentReminderStatus) {
        setTitleModal(root.$t('CONFIRM_CREATE_PAYMENT_REMINDER_RESULT'));
        setOnConfirm(update);
        toggleConfirmModal();
      }
    };

    const onShow = () => {
      notesInputVal.value = '';
      contractsToSendNotes.value = [];
      fetchClientInfo();
      fetchDueContracts();
      fetchPaymentReminderResult();
    };

    const onHide = () => {
      toggle(false);
      dueContracts.value = [];
      paymentDate.value = null;
    };

    const showCalendar = () => {
      if (isDesktop.value) {
        refs.paymentDateBox.toggle(true);
      } else {
        calendarBottomSheetOpen.value = true;
      }
      refs.paymentDateInput.blur();
    };

    const showPhoneNumbersList = () => {
      if (isDesktop.value) {
        refs.callBtn.toggle();
      } else {
        callBottomSheetOpen.value = true;
      }
    };

    const setPaymentDate = (val) => {
      paymentDate.value = val;
      if (isDesktop.value) {
        refs.paymentDateBox.toggle(false);
      } else {
        calendarBottomSheetOpen.value = false;
      }
    };

    const calLateDays = (contract) => {
      const days = moment(paymentDate.value).diff(moment(contract.maturesOn), 'days');
      return (days >= 0) ? days : 0;
    };

    const calOverdueAmount = (contract) => {
      const days = moment(paymentDate.value).diff(moment(contract.maturesOn), 'days');
      const amount = (days >= 0) ? (+days * (contract.overdueFeePerDay || 0)) : 0;
      return Math.round(amount / 1000) * 1000;
    };

    const toggleRenew = (item) => {
      const i = dueContracts.value.findIndex((contract) => (contract.id === item.id));
      if (i < 0) return;

      const contracts = dueContracts.value.map((contract, index) => (
        (i === index)
          ? {
            ...contract,
            toRepay: false,
            toRenew: !contract.toRenew
          }
          : contract
      ));

      dueContracts.value = contracts;
    };

    const toggleFinalize = (item) => {
      const i = dueContracts.value.findIndex((contract) => (contract.id === item.id));
      if (i < 0) return;

      const contracts = dueContracts.value.map((contract, index) => (
        (i === index)
          ? {
            ...contract,
            toRenew: false,
            toRepay: !contract.toRepay
          }
          : contract
      ));

      dueContracts.value = contracts;
    };

    const startCall = (number) => {
      startOutboundCall(number);
      refs.callBtn.toggle(false);
      logService.activityLog(logKeys.PAYMENT_REMINDER_CALL);
    };

    const confirm = (item) => {
      try {
        const { status } = item;

        if (status !== ASSET_STATUSES.WAITING_TO_LIQUIDIZE) {
          setTitleModal(root.$t('CONFIRM_LIQUIDATION'));
        } else {
          setTitleModal(root.$t('CONFIRM_CANCEL_LIQUIDATION'));
        }
        const onConfirm = async () => {
          await loans.setContractStatus(item.id, status === ASSET_STATUSES.WAITING_TO_LIQUIDIZE ? ASSET_STATUSES.IN_STORAGE : ASSET_STATUSES.WAITING_TO_LIQUIDIZE);
          paymentDate.value = null;
          fetchDueContracts();
          info(root.$t('CONTRACT_STATUS_CHANGED'));
          logService.activityLog(logKeys.PAYMENT_REMINDER_UPDATE);
        };

        setOnConfirm(onConfirm);
        toggleConfirmModal();
      } catch(e) {
        error(e);
      }
    };

    const toggleNotes = (i) => {
      const contracts = dueContracts.value.map((contract, index) => ({
        ...contract,
        active: (i === index) ? !contract.active : false
      }));

      dueContracts.value = contracts;
    };

    const addNotes = async (e) => {
      e.preventDefault();

      if (!notesInputVal.value) return;
      if (!contractsToSendNotes.value || !contractsToSendNotes.value.length) return;

      const results = await paymentReminderServices.addMultipleContractNotes(contractsToSendNotes.value, notesInputVal.value);

      const check = results.reduce((prev, item, i) => {
        if (item?.contractId === contractsToSendNotes.value[i]) {
          prev.succeeded.push(item.contractId);
        } else {
          prev.failed.push(item.contractId);
        }

        return prev;
      }, {
        succeeded: [],
        failed: []
      });

      let msg = '';
      if (check.succeeded.length) {
        msg += vm.$t('SUCCESSFULLY_SUBMITTED_NOTES_FOR_CONTRACTS', { contracts: check.succeeded.join(', ') });
      }

      if (check.failed.length) {
        msg += vm.$t('FAILED_TO_SUBMIT_NOTES_FOR_CONTRACTS', { contracts: check.failed.join(', ') });
      }

      info(msg);
      notesInputVal.value = '';
    };

    const toggleContractsToSend = (id) => {
      const i = contractsToSendNotes.value.indexOf(id);

      if (i < 0) {
        contractsToSendNotes.value = [
          ...contractsToSendNotes.value,
          id
        ];
      } else {
        contractsToSendNotes.value = [
          ...contractsToSendNotes.value.slice(0, i),
          ...contractsToSendNotes.value.slice(i + 1, contractsToSendNotes.value.length)
        ];
      }
    };

    const cancelAppointmentBox = () => {
      paymentReminderBottomSheetOpen.value = false;
      paymentReminderNextActionDate.value = '';
    };

    const toggleOffAppointmentBox = () => {
      if (isDesktop.value) {
        refs.nextActionDateBox.toggle(false);
      } else {
        paymentReminderBottomSheetOpen.value = false;
      }
    };

    const getFullDescription = (asset) => {
      let desc = asset.description;

      Object.keys(asset.meta || {}).forEach((key) => {
        if (asset.meta[key]) {
          desc += `<br/><span style="color:#BCBCBC">${root.$t(camelToUpperSnake(key))}:</span> <span>${asset.meta[key]}</span>`;
        }
      });

      return desc;
    };

    const calculateAdjustedAmountForRenewal = (contract) => {
      if (!contract.adjustedAmount) return 0;

      if (contract.product.interestType === INTEREST_TYPE.ADVANCE) {
        let amount = contract.adjustedAmount - ((contract.adjustedAmount * contract.interestRate) / 100);
        amount = Math.round(amount / 1000);
        amount = parseInt(amount * 1000, 10);

        return amount;
      }

      return contract.adjustedAmount;
    };

    watch(isOpen, (newVal) => {
      const { modal } = refs;

      if (newVal) modal.show();
      else modal.hide();
    });

    watch(paymentDate, () => {
      const contracts = dueContracts.value.map((contract) => ({
        ...contract,
        lateDays: calLateDays(contract),
        overdueFee: calOverdueAmount(contract)
      }));

      dueContracts.value = contracts;
    });

    watch(dueContracts, (newVal) => {
      const total = newVal.reduce((pre, contract) => {
        const { toRenew, toRepay, principalAmount, interestAmount, renewalDifference, roundingFee, overdueFee, storageFee, repaidAmount, waivedAmount } = contract;
        let amount = 0;
        if (toRenew) amount += interestAmount + roundingFee + overdueFee - renewalDifference + storageFee - repaidAmount - waivedAmount + calculateAdjustedAmountForRenewal(contract);
        if (toRepay) amount += principalAmount + interestAmount + roundingFee + overdueFee - renewalDifference - repaidAmount - waivedAmount;

        return pre + amount;
      }, 0);

      totalAmount.value = total;
    });

    const { getMisc } = useAppActions(['getMisc']);

    onMounted(() => {
      if (paymentReminderClientAttitudes.value.length === 0 || paymentReminderStatuses.value.length === 0) {
        getMisc();
      }
    });

    onUnmounted(() => {
      toggle(false);
    });

    return {
      isOpen,
      cancel,
      off,
      onShow,
      onHide,
      client,
      addCommas,
      faTimes,
      faShoppingCart,
      faHourglass,
      faCheckCircle,
      faChevronDown,
      faPhone,
      totalAmount,
      paymentDate,
      faCalendarAlt,
      setPaymentDate,
      showCalendar,
      callBottomSheetOpen,
      paymentReminderBottomSheetOpen,
      calendarBottomSheetOpen,
      showPhoneNumbersList,
      dueContracts,
      toggleRenew,
      toggleFinalize,
      secondary,
      startCall,
      confirm,
      ASSET_STATUSES,
      paymentReminderNextActionDate,
      showNextActionCalendar,
      toggleNotes,
      primary,
      faPaperPlane,
      notesInputVal,
      notesInput,
      contractsToSendNotes,
      addNotes,
      toggleContractsToSend,
      cancelAppointmentBox,
      toggleOffAppointmentBox,
      isDesktop,
      filters,
      getFullDescription,
      paymentReminderStatus,
      paymentReminderStatusOptions,
      paymentReminderClientAttitude,
      paymentReminderClientAttitudeOptions,
      paymentReminderNextAction,
      paymentReminderNextActionOptions,
      PATHS,
      applyParams,
      calculateAdjustedAmountForRenewal
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#clients-details-modal {
  a {
    color: inherit;
    text-decoration: none;
  }

  .modal-dialog {
    @media (min-width: 992px) {
      max-width: calc(100vw - 120px);
    }
    max-width: 750px;
  }

  .modal-body {
    padding-top: 30px;
    padding-bottom: 20px;
  }

  .modal-footer {
    border: 0;
    padding-bottom: 20px;
    padding-right: 30px;

    .primary-button {
      margin-left: 15px;
    }
  }

  .marginTop {
    margin-top: 30px;
  }

  .marginRight {
    margin-right: 10px;
  }

  h2 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-left: 10px;

    @media (max-width: 921px) {
      font-size: 21px;
      line-height: 0.9;
    }
  }

  @media (max-width: 921px) {
    .payment-calculation {
      margin-top: 30px;
    }
  }

  .call-btn {
    position: absolute;
    top: 15px;
    right: 10px;

    .call-btn-wrapper {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      position: relative;
      cursor: pointer;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $tuftsBlue;
        border-radius: 50%;
        opacity: .2;
        transition: all .2s ease-in-out;
      }

      svg {
        color: $tuftsBlue;
        position: absolute;
        width: 20px;
        height: 20px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        transition: all .2s ease-in-out;
      }

      &:hover {
        &::before {
          opacity: 1;
        }

        svg {
          color: $babyPowder;
        }
      }
    }

    .exit {
      cursor: pointer;
      color: $geranium;
      font-size: 20px;
      width: 30px;
      transition: all .2s ease-in-out;
      animation: mymove 5s infinite;

      &:hover {
        transform: scale(1.2);
      }
    }

    .toggle-box-wrapper {
      width: 300px;

      h4 {
        font-weight: bold;
        font-size: 18px;
        text-align: center;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          padding: 10px 30px;
          transition: all .2s ease-in-out;
          border-bottom: 1px solid $alto;

          &:last-child {
            border-bottom: 0;
          }

          .text {
            display: inline-block;
            vertical-align: middle;
          }

          .call-btn-wrapper {
            width: 40px;
            height: 40px;
            display: inline-block;
            vertical-align: middle;
            margin-left: 15px;

            svg {
              width: 18px;
              height: 18px;
            }
          }
        }
      }
    }

    .contents {
      padding: 35px 15px;
    }
  }

  table.payment-details {
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;
    text-align: center;

    thead {
      tr {
        background-color: $brightMaroon;
        text-transform: uppercase;
        color: $babyPowder;

        th {
          font-weight: normal;
          padding: 10px 15px;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
          }
        }
      }
    }

    tbody {
      tr {
        &.inactive {
          opacity: 0.5;
          transition: opacity 0.3s ease-in-out;

          &:hover {
            opacity: 1;
          }
        }

        &.extra {
          background-color: $khaki;
        }

        td {
          padding: 10px 15px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
            color: $brightMaroon;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
          }

          &.total {
            text-align: right;
          }

          &.subtitle {
            line-height: 18px;

            small {
              color: $lavenderGrey;
            }
          }
        }
      }
    }
  }

  .actions {
    @media (min-width: 922px) {
      min-width: 200px;
    }

    .icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      text-align: center;
      margin-right: 7px;
      position: relative;
      cursor: pointer;
      transition: all .2s ease-in-out;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $alto;
        border-radius: 50%;
        opacity: .2;
        transition: all .2s ease-in-out;
      }

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }

      &:hover,
      &.inactive {
        &.liquidize {
          color: $cadet;

          &::before {
            background-color: $cadet;
          }
        }
      }

      &:hover,
      &.active {
        &.extend {
          color: $aoEnglish;

          &::before {
            background-color: $aoEnglish;
          }
        }

        &.finalize {
          color: $paradisePink;

          &::before {
            background-color: $paradisePink;
          }
        }
      }

      &.toggle-notes {
        margin-left: 10px;
        margin-right: 0;
        transition: all .2s ease-in-out;

        &::before {
          background-color: $babyPowder;
          opacity: 1;
          border: 1px solid $alto;
        }

        svg {
          top: calc(50% + 1px);
        }

        &.active {
          transform: rotate(180deg);
        }
      }
    }
  }

  table.payment-detail-mobile {
    width: auto;
    display: block;

    thead {
      display: block;
      tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }
    }

    tbody {
      text-align: start;
      display: block;

      tr {
        display: block;
        border-top: 1px solid $alto;
        border-bottom: 1px sold $alto;

        &:nth-child() {
          background-color: grey;
        }

        td {
          padding: 5px;
          display:block;
          border: none;
          position: relative;
          padding-left: 45%;
          min-height: 30px;


          &::before {
            position: absolute;
            top: 0;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
            text-align: center;
          }

          &.phone {
            width: 100%;
          }

          .mobile-header {
            position: absolute;
            // top: 0;
            left: 6px;
            // width: 45%;
            padding-right: 10px;
            white-space: nowrap;
            text-align: center;
            padding-left: 10px;
          }

          &:first-child {
            border: 0;
            padding-top: 20px;
          }

          &:last-child {
            border: 0;
            padding-bottom: 20px;
          }

          &.toggle-notes {
            margin: 0 5px;
            transition: all .2s ease-in-out;

            &::before {
              background-color: $babyPowder;
              opacity: 1;
              border: 1px solid $alto;
            }

            svg {
              top: calc(50% + 1px);
            }

            &.active {
              transform: rotate(180deg);
            }

            &:hover {

              svg {
                color: $blueNcs;
              }
            }
          }
        }
      }
    }
  }

  .payment-reminder-result-wrapper {
    @media (min-width: 992px) {
      padding-right: 0;
    }
  }

  .payment-reminder-result {
    .title {
      background-color: $brightMaroon;
      color: $babyPowder;
      padding: 10px 15px;
      border-radius: 3px;
      text-transform: uppercase;
    }

    .body {
      padding: 10px 15px;
      border-radius: 3px;
      border: 1px solid $alto;

      .col-right {
        @media (min-width: 992px) {
          padding-right: 0;
        }
      }

      .label {
        color: $brightMaroon;
        font-size: 18px;
        margin-bottom: -3px;
      }

      small {
        font-size: 12px;
        color: $spanishGrey;
        font-style: italic;
      }

      .autocomplete-input {
        input {
          border-radius: 4px;
          border-color: $alto;
        }
      }

      .payment-date {
        .text-input {
          input {
            border-radius: 4px;
            border-color: $alto;
          }
        }
      }

      .multiple-notes-input {
        margin-top: 20px;

        ul {
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            display: inline-block;
            background-color: $lavenderGrey;
            border-radius: 12px;
            height: 23px;
            transition: all .2s ease-in-out;
            cursor: pointer;
            padding: 4px 11px;
            margin-right: 5px;
            font-size: 10px;

            &:hover,
            &.active {
              background-color: $blueNcs;
              color: $babyPowder;
            }
          }
        }

        .text-input {
          width: 100%;
          margin-top: 7px;
          margin-bottom: 5px;

          input {
            border-color: $alto;
            border-radius: 3px;
          }

          .icon {
            transition: all .2s ease-in-out;
            cursor: pointer;

            &:hover {
              color: $paradisePink;
            }
          }
        }
      }
    }
  }

  .bottom-sheet {
    z-index: 1051;
  }
}
</style>
